export const GET_MOVIES = "GET_MOVIES";
export const GET_MOVIE_DETAIL = "GET_MOVIE_DETAIL";
export const GET_MOVIE_NAME = "GET_MOVIE_NAME";
export const DEL_MOVIE_DETAIL = "DEL_MOVIE_DETAIL";
export const DEL_MOVIES_FILTERED = "DEL_MOVIES_FILTERED";
export const FILTER_MOVIES = "FILTER_MOVIES";
export const COMING_SOON = "COMING_SOON";
export const GET_ALL_SCHEDULE = "GET_ALL_SCHEDULE";
export const GET_SCHEDULE_BY_MOVIE = "GET_SCHEDULE_BY_MOVIE";
export const GET_SCHEDULE_BY_ID = "GET_SCHEDULE_BY_ID";
export const GET_ALL_PURCHASES = "GET_ALL_PURCHASES";
export const FILTER_BY_STATUS = "FILTER_BY_STATUS";
export const FILTER_BY_MAIL = "FILTER_BY_MAIL";
export const GET_ALL_MOVIES = "GET_ALL_MOVIES";
export const GET_GENRES = "GET_GENRES";
export const GET_LANGUAGES = "GET_LANGUAGES";
export const GET_DISPLAYS = "GET_DISPLAYS";
export const RESET_SEARCH = "RESET_SEARCH";
export const GET_PRODUCTS = "GET_PRODUCTS";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_SEATS = "GET_SEATS";
export const GET_SCHEDULES = "GET_SCHEDULES";
export const RESET_SCHEDULE_BY_MOVIE = "RESET_SCHEDULE_BY_MOVIE";
export const GET_CLOUDINARY_IMG = "GET_CLOUDINARY_IMG";
export const GET_REVIEWS = "GET_REVIEWS";
export const GET_ROOMS = "GET_ROOMS";
export const DEL_SCHEDULE = "DEL_SCHEDULE";
export const GET_HISTORY_BY_EMAIL = "GET_HISTORY_BY_EMAIL";

export const GET_INACTIVE_USERS = "GET_INACTIVE_USERS";
export const GET_ACTIVE_USERS = "GET_ACTIVE_USERS";
export const FAV_MOVIES = "FAV_MOVIES";
